import { EmptyCell } from "./EmptyCell";

export const NumberCell: React.FC = ({ value }: any) =>
  value === undefined ? (
    <EmptyCell />
  ) : (
    <>{Intl.NumberFormat().format(value)}</>
  );
